import RouteConstants from '@/features/router/RouteConstants';
import { useModalContext } from '@/hooks/useModalContext';
import { EditIcon, IconButton, TrashIcon } from '@/lib';
import { FC, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { DeleteSmsSenderModal } from './DeleteSmsSenderModal';
import { SmsSender } from './types';

type SmsSenderListActionsCellProps = {
  sender: SmsSender;
  deleteFlowId?: string;
  connectorInstanceId?: string;
  isEditDisabled?: boolean;
  isDeleteDisabled?: boolean;
  onDeleted: () => void;
};

export const SmsSenderListActionsCell: FC<SmsSenderListActionsCellProps> = ({
  sender,
  deleteFlowId,
  connectorInstanceId,
  isEditDisabled,
  isDeleteDisabled,
  onDeleted,
}) => {
  const { t } = useTranslation('campaign');
  const history = useHistory();
  const { openModal } = useModalContext();

  const handleEdit = (event: SyntheticEvent) => {
    event.stopPropagation();
    if (isEditDisabled) {
      return;
    }
    history.push(RouteConstants.editSmsSender.replace(':senderId', sender.id));
  };

  const handleDelete = (event: SyntheticEvent) => {
    event.stopPropagation();
    if (isDeleteDisabled) {
      return;
    }
    openModal({
      renderContent: DeleteSmsSenderModal,
      renderContentProps: {
        sender,
        deleteFlowId,
        connectorInstanceId,
        onDeleted,
      },
      dismissable: true,
      fullWidth: false,
      fullHeight: false,
    });
  };

  return (
    <div className='flex items-center gap-1.5'>
      <IconButton
        type='button'
        intent='link-grey'
        className='!p-1.5 text-quaternary-400'
        leadingIcon={<EditIcon className='size-4' />}
        onClick={handleEdit}
        disabled={isEditDisabled}
        aria-label={t('smsWorkspace.senders.editSender')}
        title={t('smsWorkspace.senders.editSender')}
      />
      <IconButton
        type='button'
        intent='link-grey'
        className='!p-1.5 text-red-600 hover:text-red-800'
        leadingIcon={<TrashIcon className='size-4' />}
        onClick={handleDelete}
        disabled={isDeleteDisabled}
        aria-label={t('smsWorkspace.senders.deleteSender')}
        title={t('smsWorkspace.senders.deleteSender')}
      />
    </div>
  );
};
